// Lightweight pub/sub for syncing maxes and bodyweight across all athlete components.
// Uses window CustomEvents so any component can broadcast and listen without prop drilling.

export const emitMaxUpdate = (exerciseId, maxWeight) => {
  window.dispatchEvent(new CustomEvent("paladin-max-update", { detail: { exerciseId, maxWeight } }));
};

export const emitBodyweightUpdate = (bodyweight) => {
  window.dispatchEvent(new CustomEvent("paladin-bodyweight-update", { detail: { bodyweight } }));
};

export const onMaxUpdate = (callback) => {
  const handler = (e) => callback(e.detail.exerciseId, e.detail.maxWeight);
  window.addEventListener("paladin-max-update", handler);
  return () => window.removeEventListener("paladin-max-update", handler);
};

export const onBodyweightUpdate = (callback) => {
  const handler = (e) => callback(e.detail.bodyweight);
  window.addEventListener("paladin-bodyweight-update", handler);
  return () => window.removeEventListener("paladin-bodyweight-update", handler);
};
